@if (descriptorTypesEq(descriptor.descriptor.fieldType, fieldTypes.Text)) {
    <div>
        <input [ngClass]="{ 'overridden': isOverridden }"
               [(ngModel)]="textValue"
               type="text"
               [name]="descriptor.columnName"
               (ngModelChange)="notifyTextChange()"
               class="form-control"
               [disabled]="isDisabled"
               [attr.maxlength]="getMaxLength()">
    </div>
}
@if (descriptorTypesEq(descriptor.descriptor.fieldType, fieldTypes.Number)) {
    <div>
        <input [ngClass]="{ 'overridden': isOverridden }"
               [(ngModel)]="numberValue"
               type="number"
               [name]="descriptor.columnName"
               (ngModelChange)="notifyNumberChange()"
               class="form-control"
               [disabled]="isDisabled">
    </div>
}
@if (descriptorTypesEq(descriptor.descriptor.fieldType, fieldTypes.Date)) {
    <div>
        <weissman-datetime class="float-start"
                           [dateOnly]="true"
                           (change)="notifyDateChange()"
                           [(inputDate)]="dateValue"
                           [required]="false"
                           [isDisabled]="isDisabled"
                           [isOverridden]="isOverridden">
        </weissman-datetime>
    </div>
}
@if (descriptorTypesEq(descriptor.descriptor.fieldType, fieldTypes.YesNo)) {
    <div>
        <input [ngClass]="{ 'overridden': isOverridden }"
               [(ngModel)]="booleanValue"
               type="checkbox"
               (ngModelChange)="notifyBooleanChange()"
               [disabled]="isDisabled">
    </div>
}
@if (descriptorTypesEq(descriptor.descriptor.fieldType, fieldTypes.Currency)) {
    <div>
        <ws-currency-input [override]="isOverridden"
                           [(ngModel)]="numberValue"
                           [name]="descriptor.columnName"
                           [hasMargin]="false"
                           (ngModelChange)="notifyNumberChange()"
                           [disabled]="isDisabled">
        </ws-currency-input>
    </div>
}
@if (descriptorTypesEq(descriptor.descriptor.fieldType, fieldTypes.Picklist)) {
    <div>
        <select [ngClass]="{ 'overridden': isOverridden }"
                [(ngModel)]="textValue"
                (ngModelChange)="notifyTextChange()"
                [name]="descriptor.columnName"
                [disabled]="isDisabled"
                class="form-select form-select-sm">
            <option [ngValue]="null"></option>
            @for (pl of pickList; track pl) {
                <option [ngValue]="pl">{{ pl }}</option>
            }
        </select>
    </div>
}
